import { isDefined } from "@clipboard-health/util-ts";
import { type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { FCF_DEEP_LINK_PARAM_KEYS, type FcfDeepLinkParams } from "../types";

export function useHandleFcfReplacementDeepLink(modalState: UseModalState): {
  fcfDeepLinkParams: FcfDeepLinkParams | undefined;
} {
  const location = useLocation();
  const history = useHistory();
  const [params, setParams] = useState<FcfDeepLinkParams | undefined>(undefined);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const qualification = searchParams.get(FCF_DEEP_LINK_PARAM_KEYS.qualification);
    const shiftStart = searchParams.get(FCF_DEEP_LINK_PARAM_KEYS.shiftStart);
    const cancelledWorkplaceId = searchParams.get(FCF_DEEP_LINK_PARAM_KEYS.cancelledWorkplaceId);

    if (!isDefined(qualification) || !isDefined(shiftStart) || !isDefined(cancelledWorkplaceId)) {
      return;
    }

    setParams({ qualification, shiftStart, cancelledWorkplaceId });
    modalState.openModal();

    searchParams.delete(FCF_DEEP_LINK_PARAM_KEYS.qualification);
    searchParams.delete(FCF_DEEP_LINK_PARAM_KEYS.shiftStart);
    searchParams.delete(FCF_DEEP_LINK_PARAM_KEYS.cancelledWorkplaceId);
    history.replace({ search: searchParams.toString() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return { fcfDeepLinkParams: params };
}
